module.exports = "<div>\r\n    You have successfully signed out.\r\n</div>\r\n"